webpackJsonp([15],{

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return guardRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });

var guardRoute = function guardRoute(route, redirect, next) {
  var isAuthenticated = localStorage.getItem('user_details') !== null;

  if (route.matched.some(function (record) {
    return record.meta.allowAnonymous;
  })) {
    next();
  } else if (!isAuthenticated) {
    next('/login');
  } else if (isAuthenticated) {
    next();
  }
};

var routes = [{
  path: '/',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(612)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '/',
    alias: '/home',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(609)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin',
    alias: '/admin/dashboard',
    meta: { adminOnly: true },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(614)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/users',
    meta: { adminOnly: true },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(618)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/locations',
    meta: { adminOnly: true },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/buildings',
    meta: { adminOnly: true },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(613)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/admin/templates',
    meta: { adminOnly: true },
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(617)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/template/:id',
    name: 'template',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/audits',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(620)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/audit/:id',
    name: 'audit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(619)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login/:action?',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(610)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { allowAnonymous: true }
  }, {
    path: '/resetpassword/:token?',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(611)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { allowAnonymous: true }
  }]
}, {
  path: '/download-audit/:key?/:userID?',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(621)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: { allowAnonymous: true }
}, {
  path: '*',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(622)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: { allowAnonymous: true }
}];

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_global__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_dashboard__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_locations__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_buildings__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_users__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_templates__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_audits__ = __webpack_require__(343);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    global: __WEBPACK_IMPORTED_MODULE_2__modules_global__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["a" /* default */],
    dashboard: __WEBPACK_IMPORTED_MODULE_4__modules_dashboard__["a" /* default */],
    locations: __WEBPACK_IMPORTED_MODULE_5__modules_locations__["a" /* default */],
    buildings: __WEBPACK_IMPORTED_MODULE_6__modules_buildings__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_7__modules_users__["a" /* default */],
    templates: __WEBPACK_IMPORTED_MODULE_8__modules_templates__["a" /* default */],
    audits: __WEBPACK_IMPORTED_MODULE_9__modules_audits__["a" /* default */]
  }
}));

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(321)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(605),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_flatpickr__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_flatpickr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_flatpickr_theme_airbnb_css__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_flatpickr_theme_airbnb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_flatpickr_theme_airbnb_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jwt_decode__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jwt_decode__);




















__webpack_require__(315);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* routes */]
});

router.beforeEach(function (route, redirect, next) {
  if (__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].getters.token) {
    if (__WEBPACK_IMPORTED_MODULE_11_jwt_decode___default()(__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].getters.token).exp < Date.now() / 1000) {
      alert('Either you tried to access a restricted area or your token has expired! For security reason, please try to log in again.');
      __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('logout');
      next('/');
    }

    if (typeof route.meta.adminOnly !== 'undefined' && route.meta.adminOnly === true && !['SuperAdmin', 'Admin'].includes(JSON.parse(__WEBPACK_IMPORTED_MODULE_11_jwt_decode___default()(__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].getters.token).roles)[0].Name)) {
      next('/');
    }
  }

  __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('toggleDropDownMenu', false);

  if (__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].getters.token !== null && typeof __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].getters.token !== 'undefined') {
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['Authorization'] = __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].getters.token;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__routes__["b" /* guardRoute */])(route, redirect, next);
});

__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('setUserToken');
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_6_axios___default.a.create({
  validateStatus: function validateStatus(status) {
    if (status === 401) {
      alert('Token expired!');
      __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('logout');
      router.go('/');
      return false;
    } else if (status === 403) {
      console.error("Seems like you don't have enough permissions to perform a specific action in this page.");

      return false;
    } else {
      return true;
    }
  }
}));

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_flatpickr___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('prettifyDate', function (value) {
  return __WEBPACK_IMPORTED_MODULE_10_moment___default()(value).format('MM/DD/YYYY hh:mm:ssa');
});

window.app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue___default.a);
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts__);










var state = {
  audit: [],
  audits: [],

  auditDetails: {
    id: null,
    key: null,
    auditor: null,
    location: null,
    building: null
  },
  downloadingPDF: false,
  buildingNoteComment: null
};

var mutations = {
  SET_AUDIT: function SET_AUDIT(_ref, value) {
    var commit = _ref.commit;

    state.audit = value;
  },
  DELETE_AUDIT: function DELETE_AUDIT(_ref2, audit) {
    var commit = _ref2.commit;

    state.audits.splice(state.audits.indexOf(audit), 1);
  },
  SET_AUDITS_TO_USER: function SET_AUDITS_TO_USER(state, audits) {
    state.audits = audits || [];
  },
  SET_ANSWER: function SET_ANSWER(state, _ref3) {
    var questionID = _ref3.questionID,
        answer = _ref3.answer;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(state.audit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var x = _step.value;

        if (x.Question.ID === questionID) {
          x.Answer = answer;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  },
  SET_COMMENTS: function SET_COMMENTS(state, _ref4) {
    var sectionID = _ref4.sectionID,
        comments = _ref4.comments;

    state.audit.forEach(function (x, i) {
      if (x.Section.ID === sectionID) {
        x.Comments = comments;
      }
    });
  },
  UPDATE_UPLOAD_PROGRESS: function UPDATE_UPLOAD_PROGRESS(state, _ref5) {
    var sectionID = _ref5.sectionID,
        percentCompleted = _ref5.percentCompleted;

    state.audit.filter(function (item) {
      if (item.Section.ID === sectionID) {
        item.UploadProgress = percentCompleted;
      }
    });
  },
  SET_AUDIT_DETAILS: function SET_AUDIT_DETAILS(state, auditDetails) {
    state.auditDetails = auditDetails;
  },
  SET_BUILDING_NOTE: function SET_BUILDING_NOTE(state, buildingNotes) {
    state.buildingNoteComment = buildingNotes;
  }
};

var actions = {
  getAll: function getAll(_ref6) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'audit/getall').then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateBuildingNote: function updateBuildingNote(_ref7, _ref8) {
    var commit = _ref7.commit;
    var surveyId = _ref8.surveyId,
        comment = _ref8.comment,
        isDefault = _ref8.isDefault;

    state.auditDetails.buildingNotes = comment;
    console.log(state);
    console.log(state.auditDetails);
    console.log(state.auditDetails.buildingNotes);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/updatebuildingnote?surveyId=' + surveyId + '&comment=' + comment + '&isDefault=' + isDefault).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBuildingNotes: function getBuildingNotes(_ref9, surveyId) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'audit/GetBuildingNotes?surveyId=' + surveyId).then(function (response) {
        if (response.data !== '') {
          commit('SET_BUILDING_NOTE', response.data.buildingNoteComment);
        }
        resolve(response.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAudit: function getAudit(_ref10, value) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'audit/get?id=' + value).then(function (response) {
        if (response.data !== '') {
          commit('SET_AUDIT', response.data.audit);
          commit('SET_AUDIT_DETAILS', response.data.auditDetails);
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAuditByKey: function getAuditByKey(_ref11, _ref12) {
    var commit = _ref11.commit;
    var key = _ref12.key,
        userID = _ref12.userID;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'audit/getbykey?key=' + key + '&userID=' + userID).then(function (response) {
        if (response.data !== '') {
          commit('SET_AUDIT', response.data.audit);
          commit('SET_AUDIT_DETAILS', response.data.auditDetails);
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAuditsAssignedToUser: function getAuditsAssignedToUser(_ref13) {
    var commit = _ref13.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'audit/GetAssignedToUser').then(function (response) {
        commit('SET_AUDITS_TO_USER', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getAuditsByLocation: function getAuditsByLocation(_ref14) {
    var commit = _ref14.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'audit/getbylocation').then(function (response) {
        commit('SET_AUDITS_TO_USER', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  assignAudit: function assignAudit(_ref15, _ref16) {
    var commit = _ref15.commit;
    var templateID = _ref16.templateID,
        buildingID = _ref16.buildingID,
        userID = _ref16.userID;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/create', {
        TemplateID: templateID,
        BuildingID: buildingID,
        AssignedTo: userID
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteAudit: function deleteAudit(_ref17, audit) {
    var commit = _ref17.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/delete', {
        ID: audit.ID
      }).then(function (response) {
        if (response) {
          commit('DELETE_AUDIT', audit);
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateAnswer: function updateAnswer(_ref18, _ref19) {
    var commit = _ref18.commit;
    var auditID = _ref19.auditID,
        questionID = _ref19.questionID,
        answer = _ref19.answer;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('SET_ANSWER', {
        questionID: questionID,
        answer: answer
      });

      var answers = state.audit;
      answers = answers.filter(function (item) {
        return item.Answer.ID !== null;
      }).map(function (x) {
        return {
          QuestionID: x.Question.ID,
          AnswerID: x.Answer.ID,
          Photos: []
        };
      });

      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/update', {
        ID: auditID,
        Answers: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(answers)
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateComments: function updateComments(_ref20, _ref21) {
    var commit = _ref20.commit;
    var auditID = _ref21.auditID,
        sectionID = _ref21.sectionID,
        comments = _ref21.comments;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('SET_COMMENTS', {
        sectionID: sectionID,
        comments: comments
      });

      var cmts = state.audit;
      var sections = [];

      cmts = cmts.filter(function (item) {
        return item.Section.Comments !== null;
      }).map(function (x) {
        if (sections.indexOf(x.Section.ID) === -1) {
          sections.push(x.Section.ID);
          return {
            SectionID: x.Section.ID,
            Comments: x.Comments
          };
        }
      }).filter(function (item) {
        return item !== undefined;
      });
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/updateComments', {
        ID: auditID,
        Comments: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(cmts)
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  resetAuditSelection: function resetAuditSelection(_ref22) {
    var commit = _ref22.commit;

    commit('SET_AUDIT', []);
  },
  uploadPhoto: function uploadPhoto(_ref23, _ref24) {
    var commit = _ref23.commit;
    var photos = _ref24.photos,
        sectionID = _ref24.sectionID;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var config = {
        onUploadProgress: function onUploadProgress(progressEvent) {
          var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          commit('UPDATE_UPLOAD_PROGRESS', {
            sectionID: sectionID,
            percentCompleted: percentCompleted
          });
        }
      };

      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/uploadphoto', photos, config).then(function (response) {
        state.audit.filter(function (x) {
          if (x.Section.ID === sectionID) {
            if (x.Section.Photos !== null && x.Section.Photos !== '') {
              x.Section.Photos += ',' + response.data;
            } else {
              x.Section.Photos = response.data;
            }
          }
        });
        resolve(response);
      }).catch(function (err) {
        reject(err.message);
      });
    });
  },
  deletePhoto: function deletePhoto(_ref25, _ref26) {
    var commit = _ref25.commit;
    var filename = _ref26.filename,
        auditID = _ref26.auditID,
        sectionID = _ref26.sectionID;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/deletephoto?filename=' + filename + '&auditID=' + auditID + '&sectionID=' + sectionID).then(function (response) {
        if (!response) return;

        state.audit.filter(function (x) {
          if (x.Section.ID === sectionID) {
            x.Section.Photos = x.Section.Photos.replace('' + filename, '').replace(',,', ',');

            if (x.Section.Photos.charAt(0) === ',') {
              x.Section.Photos = x.Section.Photos.substring(1);
            } else if (x.Section.Photos.charAt(x.Section.Photos.length - 1) === ',') {
              x.Section.Photos = x.Section.Photos.substring(0, x.Section.Photos.length - 1);
            }
          }
        });
        resolve(response);
      }).catch(function (err) {
        reject(err.message);
      });
    });
  },
  resetUploadProgress: function resetUploadProgress(_ref27, sectionID) {
    var commit = _ref27.commit;

    commit('UPDATE_UPLOAD_PROGRESS', {
      sectionID: sectionID,
      percentCompleted: 0
    });
  },
  getReport: function getReport(_ref28, _ref29) {
    var commit = _ref28.commit;
    var start = _ref29.start,
        end = _ref29.end;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'report/get?start=' + start + '&end=' + end).then(function (response) {
        if (response.data === '') {
          reject(new Error('No data found.'));
          alert('No data found.');
        } else {
          resolve(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getReportByLocation: function getReportByLocation(_ref30, _ref31) {
    var commit = _ref30.commit;
    var locationID = _ref31.locationID,
        start = _ref31.start,
        end = _ref31.end;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'report/getByLocation?locationID=' + locationID + '&start=' + start + '&end=' + end).then(function (response) {
        if (response.data === '') {
          reject(new Error('No data found.'));
        } else {
          resolve(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getReportByBuilding: function getReportByBuilding(_ref32, _ref33) {
    var commit = _ref32.commit;
    var buildingID = _ref33.buildingID,
        start = _ref33.start,
        end = _ref33.end;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'report/getByBuilding?buildingID=' + buildingID + '&start=' + start + '&end=' + end).then(function (response) {
        if (response.data === '') {
          reject(new Error('No data found.'));
        } else {
          resolve(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getReportByUser: function getReportByUser(_ref34, _ref35) {
    var commit = _ref34.commit;
    var userID = _ref35.userID,
        start = _ref35.start,
        end = _ref35.end;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'report/getByUser?userID=' + userID + '&start=' + start + '&end=' + end).then(function (response) {
        if (response.data === '') {
          reject(new Error('No data found.'));
        } else {
          resolve(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  downloadPDF: function downloadPDF(_ref36) {
    var commit = _ref36.commit,
        rootState = _ref36.rootState;

    state.downloadingPDF = true;
    __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts__["pdfMake"].vfs;

    var content = [];

    content.push({
      image: rootState.global.logo,
      width: 150,
      margin: [0, 0, 0, 25]
    });

    var score = 0;
    rootState.audits.audit.forEach(function (x) {
      score += x.Answer.Value;
    });
    score = (score / rootState.audits.auditDetails.maxScore * 100).toFixed(0).replace('.00', '') + '%';

    content.push({
      style: 'tableExample',
      table: {
        headerRows: 1,
        widths: [125, 150, '*', '*', '*'],
        body: [[{
          text: 'Location',
          fontSize: 10,
          bold: true
        }, {
          text: 'Building',
          fontSize: 10,
          bold: true
        }, {
          text: 'Auditor',
          fontSize: 10,
          bold: true,
          alignment: 'right'
        }, {
          text: 'Score',
          fontSize: 10,
          bold: true,
          alignment: 'right'
        }, {
          text: 'Created On',
          fontSize: 10,
          bold: true,
          alignment: 'right'
        }], [{
          text: state.auditDetails.location,
          fontSize: 12,
          bold: false
        }, {
          text: state.auditDetails.building,
          fontSize: 12,
          bold: false
        }, {
          text: state.auditDetails.auditor,
          fontSize: 12,
          bold: false,
          alignment: 'right'
        }, {
          text: score,
          fontSize: 12,
          bold: false,
          alignment: 'right'
        }, {
          text: __WEBPACK_IMPORTED_MODULE_6_moment___default()(state.auditDetails.createdOn).format('MM/DD/YYYY'),
          fontSize: 10,
          bold: false,
          alignment: 'right'
        }]]
      },
      layout: 'noBorders'
    });

    content.push({
      text: '__________________________________________________________________________________________________________________',
      color: '#ccc',
      fontSize: 10,
      margin: [0, 0, 0, 5]
    });
    var buildingNotes = state.auditDetails.buildingNotes;
    if (buildingNotes) {
      content.push({
        text: 'Building Notes',
        fontSize: 14,
        bold: true,
        margin: [0, 15, 0, 5]
      }, {
        text: state.auditDetails.buildingNotes,
        fontSize: 12,
        bold: false,
        alignment: 'left'
      });
    }

    var sections = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(state.audit.map(function (x) {
      return x.Section.ID;
    }))));

    var photos = [];
    sections.forEach(function (sectionID) {
      var filenames = state.audit.filter(function (y) {
        return y.Section.ID === sectionID;
      })[0].Section.Photos;
      if (filenames) {
        filenames.split(',').forEach(function (filename) {
          photos.push({
            sectionID: sectionID,
            filename: filename
          });
        });
      }
    });

    var promises = [];
    if (photos) {
      photos.forEach(function (item) {
        promises.push(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get('/uploads/' + state.auditDetails.id + '/' + item.sectionID + '/resized_' + item.filename, {
            responseType: 'arraybuffer'
          }).then(function (response) {
            var image = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, ''));
            resolve({
              sectionID: item.sectionID,
              dataURL: 'data:' + response.headers['content-type'].toLowerCase() + ';base64,' + image
            });
          });
        }));
      });
    }
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(promises).then(function (dataURLs) {
      sections.forEach(function (sectionID) {
        var title = state.audit.filter(function (y) {
          return y.Section.ID === sectionID;
        })[0].Section.Text;
        content.push({
          text: title,
          fontSize: 15,
          bold: true,
          margin: [0, 15, 0, 5]
        });

        var body = [];

        body.push([{
          text: 'Item',
          fontSize: 14,
          bold: true
        }, {
          text: 'Answer',
          fontSize: 14,
          bold: true
        }]);

        state.audit.filter(function (y) {
          return y.Section.ID === sectionID;
        }).forEach(function (x) {
          return body.push([x.Question.Text, x.Answer.Text]);
        });

        content.push({
          table: {
            headerRows: 1,
            widths: ['*', 75],
            body: body
          }
        });

        var comments = state.audit.filter(function (y) {
          return y.Section.ID === sectionID;
        })[0].Section.Comments;
        if (comments) {
          content.push({
            text: 'Comments',
            fontSize: 14,
            bold: true,
            margin: [0, 15, 0, 5]
          }, {
            text: comments,
            fontSize: 12
          });
        }

        var images = dataURLs.filter(function (x) {
          return x.sectionID === sectionID;
        });
        if (images) {
          var columns = [];
          var margin = [0, 10, 0, 0];
          var columnGap = 10;
          images.forEach(function (image, i) {
            columns.push({
              image: image.dataURL,
              width: 252.5
            });

            if (columns.length === 2) {
              content.push({
                columns: columns,
                margin: margin,
                columnGap: columnGap
              });
              columns = [];
            } else if (images.length === i + 1) {
              content.push({
                columns: columns,
                margin: margin,
                columnGap: columnGap
              });
            }
          });
        }
      });

      var styles = {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10]
        }
      };

      var docDefinition = {
        content: content,
        styles: styles
      };
      __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download(state.auditDetails.building + ' - ' + state.auditDetails.location + ' - ' + state.auditDetails.auditor + '.pdf');
      state.downloadingPDF = false;
    });
  },
  sendReport: function sendReport(_ref37, email) {
    var commit = _ref37.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audit/sendreport?auditKey=' + state.auditDetails.key + '&email=' + email).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  notifyAdminsAuditIsComplete: function notifyAdminsAuditIsComplete(_ref38) {
    var commit = _ref38.commit;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].axios.get(window.config.apiUrl + 'audit/sendcompletionemail?auditID=' + state.auditDetails.id).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  sections: function sections() {
    if (state.audit === '') return;
    return state.audit.filter(function (thing, index, self) {
      return self.findIndex(function (t) {
        return t.Section.ID === thing.Section.ID && t.Section.Text === thing.Section.Text;
      }) === index;
    });
  },
  audit: function audit() {
    return state.audit;
  },
  auditDetails: function auditDetails() {
    return state.auditDetails;
  },
  userAudits: function userAudits() {
    return state.audits;
  },
  auditScore: function auditScore() {
    var score = 0;

    state.audit.forEach(function (x) {
      if (x.Answer.Value !== null) {
        score += x.Answer.Value;
      }
    });

    score = (score / (state.audit.length * 4) * 100).toFixed(0).replace('.00', '');

    return score;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(32);




var state = {
  token: null,
  role: null,
  user: null
};

var mutations = {
  SET_USER_TOKEN: function SET_USER_TOKEN(state, token) {
    var _token = void 0;

    try {
      _token = JSON.parse(localStorage.getItem('token'));
    } catch (e) {
      localStorage.removeItem('token');
      _token = null;
    }

    state.token = _token;
  },
  SET_USER_DETAILS: function SET_USER_DETAILS(state) {
    var _userDetails = void 0;

    try {
      _userDetails = JSON.parse(localStorage.getItem('user_details'));
    } catch (e) {
      localStorage.removeItem('user_details');
      _userDetails = null;
    }

    state.user = _userDetails;
  },
  LOGOUT: function LOGOUT(state) {
    localStorage.removeItem('token');
    localStorage.removeItem('user_details');
    state.token = null;
    state.role = null;
    state.user = null;
    state.audits = [];
  }
};

var actions = {
  login: function login(_ref, _ref2) {
    var commit = _ref.commit;
    var email = _ref2.email,
        password = _ref2.password;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.post(window.config.apiUrl + 'jwt/AuthUser', {
        Email: email,
        Password: password
      }).then(function (response) {
        if (response.data !== '') {
          localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.token));
          localStorage.setItem('user_details', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.user_details));

          commit('SET_USER_DETAILS');

          commit('SET_USER_TOKEN');
          resolve(response);
        } else {
          reject(new Error('Authentication failed!'));
        }
      }).catch(function (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('user_details');
        reject(error);
      });
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('LOGOUT');
      resolve();
    });
  },
  setUserToken: function setUserToken(_ref4) {
    var commit = _ref4.commit;

    commit('SET_USER_TOKEN');
  },
  setUserRole: function setUserRole(_ref5) {
    var commit = _ref5.commit;

    if (localStorage.getItem('user_details') === null) return;
    state.role = JSON.parse(localStorage.getItem('user_details')).roles[0].name;
  },
  requestPasswordReset: function requestPasswordReset(_ref6, email) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.post(window.config.apiUrl + 'Users/RequestPasswordReset', {
        Email: email
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('user_details');
        reject(error);
      });
    });
  },
  setNewPassword: function setNewPassword(_ref7, user) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.post(window.config.apiUrl + 'Users/SetNewPassword', user).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateNotificationConfig: function updateNotificationConfig(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit,
        rootState = _ref8.rootState;

    var user = JSON.parse(localStorage.getItem('user_details'));

    var newNotificationValue = typeof user.notificationsConfig === 'undefined' || user.notificationsConfig === null ? false : !user.notificationsConfig[0].optIn;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.post(window.config.apiUrl + 'Users/UpdateNotificationsConfig', {
        notificationsConfig: [{
          optIn: newNotificationValue
        }]
      }).then(function (response) {
        user.notificationsConfig = [{
          optIn: newNotificationValue
        }];

        localStorage.setItem('user_details', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));

        commit('SET_USER_DETAILS');
        resolve(response);
      }).catch(function (error) {
        alert('Something went wrong, we couldn\'t update your settings.');
        console.error(error);
        reject(error);
      });
    });
  }
};

var getters = {
  loggedUser: function loggedUser() {
    return state.user || JSON.parse(localStorage.getItem('user_details'));
  },
  token: function token() {
    return state.token ? 'Bearer ' + state.token.access_token : null;
  },
  getAuthenticationHeader: function getAuthenticationHeader() {
    return state.token ? { 'Authorization': 'Bearer ' + state.token.access_token } : null;
  },
  getUserRole: function getUserRole() {
    return state.role;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);



var state = {
  building: {},
  buildings: []
};

var mutations = {
  SET_BUILDING: function SET_BUILDING(_ref, value) {
    var commit = _ref.commit;

    state.building = value || {};
  },
  SET_BUILDINGS: function SET_BUILDINGS(_ref2, value) {
    var commit = _ref2.commit;

    state.buildings = value || [];
  },
  ADD_BUILDING: function ADD_BUILDING(_ref3, value) {
    var commit = _ref3.commit;

    state.buildings.push(value);
  },
  REMOVE_BUILDING: function REMOVE_BUILDING(_ref4, value) {
    var commit = _ref4.commit;

    state.buildings.splice(state.buildings.indexOf(value), 1);
  }
};

var actions = {
  getBuildings: function getBuildings(_ref5) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(window.config.apiUrl + 'building/getall').then(function (response) {
        commit('SET_BUILDINGS', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBuildingsByLocation: function getBuildingsByLocation(_ref6, locationID) {
    var commit = _ref6.commit;

    var params = typeof locationID !== 'undefined' ? '?locationID=' + locationID : '';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(window.config.apiUrl + 'building/getbylocation' + params).then(function (response) {
        commit('SET_BUILDINGS', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createBuilding: function createBuilding(_ref7, building) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var location = building.locationId !== null ? { Id: building.locationId } : null;

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'building/create', {
        Name: building.name,
        Location: location
      }).then(function (response) {
        if (response.data !== '') {
          commit('ADD_BUILDING', response.data);
          resolve(response);
        } else {
          reject(new Error('Building already exists.'));
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateBuilding: function updateBuilding(_ref8, building) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'building/update', {
        ID: building.ID,
        Name: building.Name
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteBuilding: function deleteBuilding(_ref9, building) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'building/delete', {
        ID: building.ID
      }).then(function (response) {
        if (response.data) {
          commit('REMOVE_BUILDING', building);
          resolve(response);
        } else {
          reject(new Error('Something went wrong.'));
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  building: function building() {
    return state.building;
  },
  buildings: function buildings() {
    return state.buildings;
  },
  buildingsByLocation: function buildingsByLocation() {
    return state.buildings.reduce(function (acc, item) {
      var key = item.Location.Name;
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);



var state = {
  stats: [],
  graphData: {},
  graphDataAvg: {}
};

var mutations = {
  SET_DASHBOARD_STATS: function SET_DASHBOARD_STATS(state, data) {
    state.stats = data;
  },
  SET_GRAPH_DATA: function SET_GRAPH_DATA(_ref, _ref2) {
    var commit = _ref.commit;
    var labels = _ref2.labels,
        data = _ref2.data;

    state.graphData = {
      labels: labels,
      data: data
    };
  },
  SET_GRAPH_DATA_AVG: function SET_GRAPH_DATA_AVG(_ref3, _ref4) {
    var commit = _ref3.commit;
    var labels = _ref4.labels,
        data = _ref4.data;

    state.graphDataAvg = {
      labels: labels,
      data: data
    };
  }
};

var actions = {
  getDashboardStats: function getDashboardStats(_ref5) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(window.config.apiUrl + 'users/GetDashboardStats').then(function (response) {
        commit('SET_DASHBOARD_STATS', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setGraphData: function setGraphData(_ref6, _ref7) {
    var commit = _ref6.commit;
    var labels = _ref7.labels,
        data = _ref7.data;

    commit('SET_GRAPH_DATA', { labels: labels, data: data });
  },
  setGraphDataAvg: function setGraphDataAvg(_ref8, _ref9) {
    var commit = _ref8.commit;
    var labels = _ref9.labels,
        data = _ref9.data;

    commit('SET_GRAPH_DATA_AVG', { labels: labels, data: data });
  }
};

var getters = {
  getDashboardStats: function getDashboardStats() {
    return state.stats;
  },
  getGraphData: function getGraphData() {
    return state.graphData;
  },
  getGraphDataAvg: function getGraphDataAvg() {
    return state.graphDataAvg;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  isDropdownMenuOpen: false,
  logo: 'data:image/png;base64,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',
  menu: []
};

var mutations = {
  TOGGLE_DROPDOW_MENU: function TOGGLE_DROPDOW_MENU(state, value) {
    state.isDropdownMenuOpen = value;
  },
  SET_MENU: function SET_MENU(state, options) {
    state.menu = options;
  }
};

var actions = {
  toggleDropDownMenu: function toggleDropDownMenu(_ref, value) {
    var commit = _ref.commit;

    commit('TOGGLE_DROPDOW_MENU', value);
  }
};

var getters = {
  dropDownMenuState: function dropDownMenuState(state) {
    return state.isDropdownMenuOpen;
  },
  logo: function logo(state) {
    return state.logo;
  },
  menu: function menu(state, getters, rootState) {
    if (rootState.auth.role === 'SuperAdmin' || rootState.auth.role === 'Admin') {
      return [{
        name: 'Dashboard',
        link: '/admin/dashboard'
      }, {
        name: 'Locations',
        link: '/admin/locations'
      }, {
        name: 'Users',
        link: '/admin/users'
      }, {
        name: 'Buildings',
        link: '/admin/buildings'
      }, {
        name: 'Audit Templates',
        link: '/admin/templates'
      }, {
        name: 'Audits',
        link: '/audits'
      }];
    } else {
      return [{
        name: 'Audits',
        link: '/audits'
      }];
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);



var state = {
  location: {},
  locations: []
};

var mutations = {
  SET_LOCATION: function SET_LOCATION(_ref, value) {
    var commit = _ref.commit;

    state.location = value;
  },
  SET_LOCATIONS: function SET_LOCATIONS(_ref2, value) {
    var commit = _ref2.commit;

    state.locations = value || [];
  },
  ADD_LOCATION: function ADD_LOCATION(_ref3, value) {
    var commit = _ref3.commit;

    state.locations.push(value);
  },
  REMOVE_LOCATION: function REMOVE_LOCATION(_ref4, value) {
    var commit = _ref4.commit;

    state.locations.splice(state.locations.indexOf(value), 1);
  }
};

var actions = {
  getLocations: function getLocations(_ref5) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(window.config.apiUrl + 'location/getbyuser').then(function (response) {
        commit('SET_LOCATIONS', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createLocation: function createLocation(_ref6, name) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'location/create', {
        Name: name,
        TimeZone: 'US Eastern Standard Time'
      }).then(function (response) {
        if (response.data > 0) {
          commit('ADD_LOCATION', { ID: response.data, Name: name });
          resolve(response);
        } else {
          reject(new Error('Location already exists.'));
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateLocation: function updateLocation(_ref7, location) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'location/update', {
        ID: location.ID,
        Name: location.Name
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteLocation: function deleteLocation(_ref8, location) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'location/delete', {
        ID: location.ID
      }).then(function (response) {
        if (response.data) {
          commit('REMOVE_LOCATION', location);
          resolve(response);
        } else {
          reject(new Error('Something went wrong.'));
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  location: function location() {
    return state.location;
  },
  locations: function locations() {
    return state.locations;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(32);



var state = {
  masterTemplate: [],
  template: [],
  templates: [],
  assignTemplateValues: {
    templateID: '',
    userID: '',
    locationID: ''
  }
};

var mutations = {
  SET_MASTER_TEMPLATE: function SET_MASTER_TEMPLATE(_ref, value) {
    var commit = _ref.commit;

    state.masterTemplate = value;
  },
  SET_TEMPLATES: function SET_TEMPLATES(_ref2, value) {
    var commit = _ref2.commit;

    state.templates = value || [];
  },
  ADD_TEMPLATE: function ADD_TEMPLATE(_ref3, value) {
    var commit = _ref3.commit;

    var index = state.templates.findIndex(function (x) {
      return x.ID === value.ID;
    });
    if (index > -1) {
      state.templates[index] = value;
    } else {
      state.templates.unshift(value);
    }
  },
  DELETE_TEMPLATE: function DELETE_TEMPLATE(_ref4, template) {
    var commit = _ref4.commit;

    state.templates.splice(state.templates.indexOf(template), 1);
  }
};

var actions = {
  getMasterTemplate: function getMasterTemplate(_ref5) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(window.config.apiUrl + 'auditTemplate/getmaster').then(function (response) {
        commit('SET_MASTER_TEMPLATE', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getTemplates: function getTemplates(_ref6) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.get(window.config.apiUrl + 'auditTemplate/getbylocation').then(function (response) {
        commit('SET_TEMPLATES', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  upsertTemplate: function upsertTemplate(_ref7, _ref8) {
    var commit = _ref7.commit;
    var id = _ref8.id,
        name = _ref8.name,
        template = _ref8.template,
        isActive = _ref8.isActive,
        locationID = _ref8.locationID;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'auditTemplate/upsert', {
        id: id,
        name: name,
        locationID: locationID,
        isActive: isActive,
        template: template
      }).then(function (response) {
        commit('ADD_TEMPLATE', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createTemplate: function createTemplate(_ref9, _ref10) {
    var commit = _ref9.commit;
    var name = _ref10.name,
        template = _ref10.template,
        locationID = _ref10.locationID;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'auditTemplate/create', {
        name: name,
        locationID: locationID,
        template: template
      }).then(function (response) {
        commit('ADD_TEMPLATE', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteTemplate: function deleteTemplate(_ref11, template) {
    var commit = _ref11.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.post(window.config.apiUrl + 'audittemplate/delete', {
        ID: template.ID
      }).then(function (response) {
        if (response) {
          commit('DELETE_TEMPLATE', template);
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  masterTemplate: function masterTemplate() {
    return state.masterTemplate.reduce(function (acc, item) {
      var key = item.SectionName;
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});
  },
  template: function template() {
    return state.template;
  },
  templates: function templates() {
    return state.templates;
  },
  assignTemplateValues: function assignTemplateValues() {
    return state.assignTemplateValues;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(32);




var state = {
  users: [],
  roles: []
};

var mutations = {
  SET_USERS: function SET_USERS(_ref, value) {
    var commit = _ref.commit;

    state.users = value || [];
  },
  SET_ROLES: function SET_ROLES(_ref2, value) {
    var commit = _ref2.commit;

    state.roles = value;
  },
  ADD_USER: function ADD_USER(_ref3, value) {
    var commit = _ref3.commit;

    state.users.push(value);
  },
  DELETE_USER: function DELETE_USER(_ref4, user) {
    var commit = _ref4.commit;

    state.users.splice(state.users.indexOf(user), 1);
  },
  UPDATE_USER: function UPDATE_USER(_ref5, user) {
    var commit = _ref5.commit;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var u = _step.value;

        if (u.ID === user.ID) {
          u.Location.ID = user.Location.ID;
          u.Location.Name = user.Location.Name;
          u.Roles[0].Name = user.Roles[0].Name;
          u.Roles[0].ID = user.Roles[0].ID;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
};

var actions = {
  getUsers: function getUsers(_ref6) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.get(window.config.apiUrl + 'users/getbylocation').then(function (response) {
        commit('SET_USERS', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRoles: function getRoles(_ref7) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.get(window.config.apiUrl + 'users/getroles').then(function (response) {
        commit('SET_ROLES', response.data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createUser: function createUser(_ref8, user) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.post(window.config.apiUrl + 'users/create', user).then(function (response) {
        if (response.data !== '') {
          commit('ADD_USER', response.data);
          resolve(response);
        } else {
          reject(new Error('User already exists.'));
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateUser: function updateUser(_ref9, user) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.post(window.config.apiUrl + 'users/update', user).then(function (response) {
        if (response.data !== -1) {
          commit('UPDATE_USER', response.data);
        } else {
          reject(new Error('The email address is already being used by another user.'));
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteUser: function deleteUser(_ref10, user) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].axios.post(window.config.apiUrl + 'users/delete', user).then(function (response) {
        if (response.data) {
          commit('DELETE_USER', user);
        }
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var getters = {
  users: function users() {
    return state.users;
  },
  roles: function roles() {
    return state.roles;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    this.$store.dispatch('setUserToken');
    this.$store.dispatch('setUserRole');
  }
});

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 195,
	"./af.js": 195,
	"./ar": 202,
	"./ar-dz": 196,
	"./ar-dz.js": 196,
	"./ar-kw": 197,
	"./ar-kw.js": 197,
	"./ar-ly": 198,
	"./ar-ly.js": 198,
	"./ar-ma": 199,
	"./ar-ma.js": 199,
	"./ar-sa": 200,
	"./ar-sa.js": 200,
	"./ar-tn": 201,
	"./ar-tn.js": 201,
	"./ar.js": 202,
	"./az": 203,
	"./az.js": 203,
	"./be": 204,
	"./be.js": 204,
	"./bg": 205,
	"./bg.js": 205,
	"./bn": 206,
	"./bn.js": 206,
	"./bo": 207,
	"./bo.js": 207,
	"./br": 208,
	"./br.js": 208,
	"./bs": 209,
	"./bs.js": 209,
	"./ca": 210,
	"./ca.js": 210,
	"./cs": 211,
	"./cs.js": 211,
	"./cv": 212,
	"./cv.js": 212,
	"./cy": 213,
	"./cy.js": 213,
	"./da": 214,
	"./da.js": 214,
	"./de": 217,
	"./de-at": 215,
	"./de-at.js": 215,
	"./de-ch": 216,
	"./de-ch.js": 216,
	"./de.js": 217,
	"./dv": 218,
	"./dv.js": 218,
	"./el": 219,
	"./el.js": 219,
	"./en-au": 220,
	"./en-au.js": 220,
	"./en-ca": 221,
	"./en-ca.js": 221,
	"./en-gb": 222,
	"./en-gb.js": 222,
	"./en-ie": 223,
	"./en-ie.js": 223,
	"./en-nz": 224,
	"./en-nz.js": 224,
	"./eo": 225,
	"./eo.js": 225,
	"./es": 227,
	"./es-do": 226,
	"./es-do.js": 226,
	"./es.js": 227,
	"./et": 228,
	"./et.js": 228,
	"./eu": 229,
	"./eu.js": 229,
	"./fa": 230,
	"./fa.js": 230,
	"./fi": 231,
	"./fi.js": 231,
	"./fo": 232,
	"./fo.js": 232,
	"./fr": 235,
	"./fr-ca": 233,
	"./fr-ca.js": 233,
	"./fr-ch": 234,
	"./fr-ch.js": 234,
	"./fr.js": 235,
	"./fy": 236,
	"./fy.js": 236,
	"./gd": 237,
	"./gd.js": 237,
	"./gl": 238,
	"./gl.js": 238,
	"./gom-latn": 239,
	"./gom-latn.js": 239,
	"./he": 240,
	"./he.js": 240,
	"./hi": 241,
	"./hi.js": 241,
	"./hr": 242,
	"./hr.js": 242,
	"./hu": 243,
	"./hu.js": 243,
	"./hy-am": 244,
	"./hy-am.js": 244,
	"./id": 245,
	"./id.js": 245,
	"./is": 246,
	"./is.js": 246,
	"./it": 247,
	"./it.js": 247,
	"./ja": 248,
	"./ja.js": 248,
	"./jv": 249,
	"./jv.js": 249,
	"./ka": 250,
	"./ka.js": 250,
	"./kk": 251,
	"./kk.js": 251,
	"./km": 252,
	"./km.js": 252,
	"./kn": 253,
	"./kn.js": 253,
	"./ko": 254,
	"./ko.js": 254,
	"./ky": 255,
	"./ky.js": 255,
	"./lb": 256,
	"./lb.js": 256,
	"./lo": 257,
	"./lo.js": 257,
	"./lt": 258,
	"./lt.js": 258,
	"./lv": 259,
	"./lv.js": 259,
	"./me": 260,
	"./me.js": 260,
	"./mi": 261,
	"./mi.js": 261,
	"./mk": 262,
	"./mk.js": 262,
	"./ml": 263,
	"./ml.js": 263,
	"./mr": 264,
	"./mr.js": 264,
	"./ms": 266,
	"./ms-my": 265,
	"./ms-my.js": 265,
	"./ms.js": 266,
	"./my": 267,
	"./my.js": 267,
	"./nb": 268,
	"./nb.js": 268,
	"./ne": 269,
	"./ne.js": 269,
	"./nl": 271,
	"./nl-be": 270,
	"./nl-be.js": 270,
	"./nl.js": 271,
	"./nn": 272,
	"./nn.js": 272,
	"./pa-in": 273,
	"./pa-in.js": 273,
	"./pl": 274,
	"./pl.js": 274,
	"./pt": 276,
	"./pt-br": 275,
	"./pt-br.js": 275,
	"./pt.js": 276,
	"./ro": 277,
	"./ro.js": 277,
	"./ru": 278,
	"./ru.js": 278,
	"./sd": 279,
	"./sd.js": 279,
	"./se": 280,
	"./se.js": 280,
	"./si": 281,
	"./si.js": 281,
	"./sk": 282,
	"./sk.js": 282,
	"./sl": 283,
	"./sl.js": 283,
	"./sq": 284,
	"./sq.js": 284,
	"./sr": 286,
	"./sr-cyrl": 285,
	"./sr-cyrl.js": 285,
	"./sr.js": 286,
	"./ss": 287,
	"./ss.js": 287,
	"./sv": 288,
	"./sv.js": 288,
	"./sw": 289,
	"./sw.js": 289,
	"./ta": 290,
	"./ta.js": 290,
	"./te": 291,
	"./te.js": 291,
	"./tet": 292,
	"./tet.js": 292,
	"./th": 293,
	"./th.js": 293,
	"./tl-ph": 294,
	"./tl-ph.js": 294,
	"./tlh": 295,
	"./tlh.js": 295,
	"./tr": 296,
	"./tr.js": 296,
	"./tzl": 297,
	"./tzl.js": 297,
	"./tzm": 299,
	"./tzm-latn": 298,
	"./tzm-latn.js": 298,
	"./tzm.js": 299,
	"./uk": 300,
	"./uk.js": 300,
	"./ur": 301,
	"./ur.js": 301,
	"./uz": 303,
	"./uz-latn": 302,
	"./uz-latn.js": 302,
	"./uz.js": 303,
	"./vi": 304,
	"./vi.js": 304,
	"./x-pseudo": 305,
	"./x-pseudo.js": 305,
	"./yo": 306,
	"./yo.js": 306,
	"./zh-cn": 307,
	"./zh-cn.js": 307,
	"./zh-hk": 308,
	"./zh-hk.js": 308,
	"./zh-tw": 309,
	"./zh-tw.js": 309
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 599;

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ })

},[342]);


// WEBPACK FOOTER //
// static/js/app.f456f5be68ba41cfaede.js